import { render } from "./ELECTED_VACATION_STARTED.vue?vue&type=template&id=36cbeedc"
import script from "./ELECTED_VACATION_STARTED.vue?vue&type=script&lang=js"
export * from "./ELECTED_VACATION_STARTED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__